import React from 'react';
import MediaEvaluationPanel from '../components/MediaEvaluationPanel';

export default function MediaEvaluationPage() {
  return (
    <div className="main">
      <div className="page-header">
        <h1 className="page-title">언론매체 평가</h1>
      </div>
      <MediaEvaluationPanel />
    </div>
  );
}
